import React, { FC } from "react";
import { PaymentInstrumentSelect, Section } from "@lookiero/payments-front";
import { useStaticInfo } from "../../../../hooks/useStaticInfo";

interface PaymentInstrumentProps {
  readonly boxUuid?: string;
  readonly useRedirect: () => Record<string, string>;
}
const PaymentInstrument: FC<PaymentInstrumentProps> = ({ boxUuid, useRedirect }) => {
  const { returnUrl } = useRedirect();
  const { customer } = useStaticInfo();

  return (
    <PaymentInstrumentSelect
      beforeRedirect={returnUrl ? () => Promise.resolve(returnUrl) : undefined}
      boxUuid={boxUuid}
      section={Section.BOX_CHECKOUT}
      userInformation={{
        email: customer.email,
        name: customer.name,
        segment: customer.segment,
      }}
      showSingleUsePaymentMethods
    />
  );
};

export { PaymentInstrument };
